var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter, Injector, OnInit } from '@angular/core';
import { AppTimezoneScope } from '@shared/AppEnums';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ClaimModifyServiceProxy, ModifyClaimDto, ProfileServiceProxy, UserClaimEditDto } from '@shared/service-proxies/service-proxies';
import * as moment from 'moment';
import { document, ModalDirective } from 'ngx-bootstrap';
import { Profile } from 'oidc-client';
import { SmsVerificationModalComponent } from './sms-verification-modal.component';
import { FormControl, Validators } from '@angular/forms';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MyNeedsCalculatorService } from '@app/shared/common/widgets/my-needs-calculator-widget/my-needs-calculator.service';
import { AppConsts } from '@shared/AppConsts';
var MySettingsModalComponent = /** @class */ (function (_super) {
    __extends(MySettingsModalComponent, _super);
    function MySettingsModalComponent(injector, _profileService, _claimModifyService, _needsCalculatorService) {
        var _this = _super.call(this, injector) || this;
        _this._profileService = _profileService;
        _this._claimModifyService = _claimModifyService;
        _this._needsCalculatorService = _needsCalculatorService;
        _this.occupations = [];
        _this.occupationsLoadError = '';
        _this.editDetailType = 'all';
        _this.modalSave = new EventEmitter();
        _this.active = false;
        _this.saving = false;
        _this.isGoogleAuthenticatorEnabled = false;
        _this.isPhoneNumberEmpty = false;
        _this.showTimezoneSelection = abp.clock.provider.supportsMultipleTimezone;
        _this.defaultTimezoneScope = AppTimezoneScope.User;
        _this._initialTimezone = undefined;
        _this.restrictionDateValue = new Date();
        _this.GenderList = ['Male', 'Female', 'Non-binary'];
        _this.wasInside = false;
        _this.enabledField = [];
        _this.occupationFormControl = new FormControl('', [Validators.required, Validators.maxLength(200)]);
        _this.addressLine1FormControl = new FormControl('', [Validators.required, Validators.maxLength(200)]);
        _this.addressLine2FormControl = new FormControl('', [Validators.maxLength(200)]);
        _this.suburbFormControl = new FormControl('', [Validators.required, Validators.maxLength(50)]);
        _this.cityFormControl = new FormControl('', [Validators.required, Validators.maxLength(50)]);
        _this.postalCodeControl = new FormControl('', [Validators.required, Validators.maxLength(10), Validators.pattern(/^\d{3,10}$/)]);
        _this.getCurrentUserInfo();
        return _this;
    }
    MySettingsModalComponent.prototype.getCurrentUserInfo = function () {
        var _this = this;
        abp.event.on('getExistsUserInfo', function () {
            _this._authService.getUser(function (res) {
                _this.existsCurrentUserInfo = res;
                var utcDate = _this.existsCurrentUserInfo.birthdate;
                _this.existsRestrictionDateValue = moment(utcDate, 'DD/MM/YYYY hh:mm:ss A').toDate();
                _this.setActiveCapture();
            });
        });
    };
    MySettingsModalComponent.prototype.setActiveCapture = function () {
        if (this.editDetailType !== 'all') {
            switch (this.editDetailType) {
                case 'profile':
                    this.show();
                    break;
                case 'contact':
                    this.contactTab();
                    break;
                case 'scheme':
                    this.schemeTab();
                    break;
                case 'other':
                    this.otherTab();
                    break;
            }
        }
    };
    MySettingsModalComponent.prototype.show = function () {
        var _this = this;
        this.active = true;
        this.restrictionMessage = false;
        this.lastTabActive = false;
        this.tabIndex = 1;
        this.profile_contact_scheme = 'profile';
        this.nameDisabled = true;
        this.surnameDisabled = true;
        this.genderDisabled = true;
        this.birthdayDisabled = true;
        this._authService.getUser(function (res) {
            _this.currentUserInfo = res;
            _this.selectedGender = _this.currentUserInfo.gender;
            var birthDate = _this.currentUserInfo.birthdate;
            _this.restrictionDateValue = moment(birthDate, 'DD/MM/YYYY hh:mm:ss A').toDate();
            abp.event.trigger('getExistsUserInfo');
            _this.setFormControlInitialValues();
            _this.clonedCurrentUserInfo = JSON.parse(JSON.stringify(_this.currentUserInfo));
            _this.modal.show();
        });
    };
    MySettingsModalComponent.prototype.profileTab = function () {
        this.lastTabActive = false;
        this.schemeDisabled = true;
        this.profile_contact_scheme = 'profile';
        this.tabIndex = 1;
        if (this.existsCurrentUserInfo.medical_scheme_membership_number !== this.currentUserInfo.medical_scheme_membership_number) {
            this.changesConfirmPopup();
        }
        else {
            this.disabledField();
        }
    };
    MySettingsModalComponent.prototype.contactTab = function () {
        this.nameDisabled = true;
        this.surnameDisabled = true;
        this.schemeDisabled = true;
        this.genderDisabled = true;
        this.birthdayDisabled = true;
        this.lastTabActive = false;
        this.profile_contact_scheme = 'contact';
        this.tabIndex = 2;
        if ((this.existsCurrentUserInfo.gender !== this.selectedGender)
            || (this.existsCurrentUserInfo.family_name !== this.currentUserInfo.family_name)
            || (this.existsCurrentUserInfo.given_name !== this.currentUserInfo.given_name)
            || this.existsRestrictionDateValue.getTime() !== this.restrictionDateValue.getTime()
            || (this.existsCurrentUserInfo.medical_scheme_membership_number !== this.currentUserInfo.medical_scheme_membership_number)) {
            this.changesConfirmPopup();
        }
        else {
            this.disabledField();
        }
    };
    MySettingsModalComponent.prototype.schemeTab = function () {
        this.profile_contact_scheme = 'scheme';
        this.tabIndex = 3;
        this.lastTabActive = false;
        this.nameDisabled = true;
        this.surnameDisabled = true;
        this.schemeDisabled = true;
        this.genderDisabled = true;
        this.birthdayDisabled = true;
        if ((this.existsCurrentUserInfo.gender !== this.selectedGender)
            || (this.existsCurrentUserInfo.family_name !== this.currentUserInfo.family_name)
            || (this.existsCurrentUserInfo.given_name !== this.currentUserInfo.given_name)
            || this.existsRestrictionDateValue.getTime() !== this.restrictionDateValue.getTime()) {
            this.changesConfirmPopup();
        }
        else {
            this.disabledField();
        }
    };
    MySettingsModalComponent.prototype.otherTab = function () {
        this.profile_contact_scheme = 'other';
        this.tabIndex = 4;
        this.lastTabActive = true;
        this.nameDisabled = true;
        this.surnameDisabled = true;
        this.schemeDisabled = true;
        this.genderDisabled = true;
        this.birthdayDisabled = true;
        if (this.currentUserInfo && ((this.existsCurrentUserInfo.occupation !== this.currentUserInfo.occupation)
            || (this.existsCurrentUserInfo.physical_address_city !== this.currentUserInfo.physical_address_city)
            || (this.existsCurrentUserInfo.physical_address_code !== this.currentUserInfo.physical_address_code)
            || (this.existsCurrentUserInfo.physical_address_line_1 !== this.currentUserInfo.physical_address_line_1)
            || (this.existsCurrentUserInfo.physical_address_line_2 !== this.currentUserInfo.physical_address_line_2)
            || (this.existsCurrentUserInfo.physical_address_suburb !== this.currentUserInfo.physical_address_suburb))) {
            this.changesConfirmPopup();
        }
        else {
            this.disabledField();
        }
    };
    MySettingsModalComponent.prototype.changesConfirmPopup = function () {
        var d = this;
        abp.message.confirm('', 'Do you want to save profile changes before you continue?', function (isConfirmed) {
            var _this = this;
            if (isConfirmed) {
                this._authservice.getUser(function (res) {
                    d.currentUserInfo = res;
                    d.selectedGender = d.currentUserInfo.gender;
                    var birthDate = d.currentUserInfo.birthdate;
                    d.restrictionDateValue = moment(birthDate, 'DD/MM/YYYY hh:mm:ss A').toDate();
                    _this.setFormControlInitialValues();
                });
            }
            else {
                d.save(null);
            }
        }, true);
        document.getElementsByClassName('swal2-confirm')[0].innerText = 'Continue without saving';
        document.getElementsByClassName('swal2-confirm')[0].classList.add('modal-button-clr');
        document.getElementsByClassName('swal2-confirm')[0].classList.add('border-radius-55');
        document.getElementsByClassName('swal2-confirm')[0].classList.add('font-size-12');
        document.getElementsByClassName('swal2-cancel')[0].innerText = 'Save';
        document.getElementsByClassName('swal2-cancel')[0].classList.add('modal-button-clr');
        document.getElementsByClassName('swal2-cancel')[0].classList.add('border-radius-55');
        document.getElementsByClassName('swal2-cancel')[0].classList.add('font-size-12');
    };
    MySettingsModalComponent.prototype.disabledField = function () {
        this.nameDisabled = true;
        this.surnameDisabled = true;
        this.schemeDisabled = true;
        this.genderDisabled = true;
        this.birthdayDisabled = true;
    };
    MySettingsModalComponent.prototype.updateQrCodeSetupImageUrl = function () {
        var _this = this;
        this._profileService.updateGoogleAuthenticatorKey().subscribe(function (result) {
            _this.user.qrCodeSetupImageUrl = result.qrCodeSetupImageUrl;
            _this.isGoogleAuthenticatorEnabled = true;
        });
    };
    MySettingsModalComponent.prototype.smsVerify = function () {
        //this._profileService.sendVerificationSms()
        //    .subscribe(() => {
        //        this.smsVerificationModal.show();
        //    });
    };
    MySettingsModalComponent.prototype.changePhoneNumberToVerified = function () {
        this.isPhoneNumberConfirmed = true;
    };
    MySettingsModalComponent.prototype.onShown = function () {
        document.getElementById('Name').focus();
    };
    MySettingsModalComponent.prototype.close = function () {
        this.active = false;
        this.modal.hide();
    };
    MySettingsModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addressLine1FormControl.valueChanges.subscribe(function (val) { return _this.currentUserInfo.physical_address_line_1 = val; });
        this.addressLine2FormControl.valueChanges.subscribe(function (val) { return _this.currentUserInfo.physical_address_line_2 = val; });
        this.suburbFormControl.valueChanges.subscribe(function (val) { return _this.currentUserInfo.physical_address_suburb = val; });
        this.cityFormControl.valueChanges.subscribe(function (val) { return _this.currentUserInfo.physical_address_city = val; });
        this.postalCodeControl.valueChanges.subscribe(function (val) { return _this.currentUserInfo.physical_address_code = val; });
        this.occupationFormControl.valueChanges.subscribe(function (val) { return _this.currentUserInfo.occupation = val; });
        this.loadOccupations();
    };
    MySettingsModalComponent.prototype.loadOccupations = function () {
        var _this = this;
        this._needsCalculatorService.getOccupationList().pipe(catchError(function () {
            var msg = _this.l ? _this.l('CouldNotLoadOccupations') : 'Failed to load occupations';
            _this.occupationsLoadError = msg;
            abp.notify.error(msg);
            return of([]);
        })).subscribe(function (res) {
            if (Array.isArray(res) && res.length > 0) {
                _this.occupations = res[0].Data || [];
            }
            else {
                _this.occupations = [];
            }
        });
    };
    MySettingsModalComponent.prototype.setFormControlInitialValues = function () {
        if (!this.currentUserInfo) {
            return;
        }
        this.occupationFormControl.setValue(this.currentUserInfo.occupation || '');
        this.addressLine1FormControl.setValue(this.currentUserInfo.physical_address_line_1 || '');
        this.addressLine2FormControl.setValue(this.currentUserInfo.physical_address_line_2 || '');
        this.suburbFormControl.setValue(this.currentUserInfo.physical_address_suburb || '');
        this.cityFormControl.setValue(this.currentUserInfo.physical_address_city || '');
        this.postalCodeControl.setValue(this.currentUserInfo.physical_address_code || '');
    };
    MySettingsModalComponent.prototype.addClaim = function (claimList, claimType, claimValue) {
        if (!claimList.userClaimEditDtos) {
            claimList.userClaimEditDtos = [];
        }
        var claim = new UserClaimEditDto();
        claim.claimType = claimType;
        claim.claimValue = claimValue === undefined || claimValue === null ? '' : claimValue;
        claimList.userClaimEditDtos.push(claim);
    };
    MySettingsModalComponent.prototype.getClaimValueFromControl = function (control, propName) {
        var val = control && control.value;
        if (val !== null && val !== undefined && val.toString().trim() !== '') {
            return val;
        }
        return this.currentUserInfo[propName] || '';
    };
    MySettingsModalComponent.prototype.hasOtherFieldsChanged = function () {
        if (!this.existsCurrentUserInfo) {
            return true;
        }
        var occupationChanged = this.clonedCurrentUserInfo.occupation !== this.getClaimValueFromControl(this.occupationFormControl, AppConsts.ClaimTypes.occupation);
        var addressLine1Changed = this.clonedCurrentUserInfo.physical_address_line_1 !== this.getClaimValueFromControl(this.addressLine1FormControl, AppConsts.ClaimTypes.physical_address_line_1);
        var addressLine2Changed = this.clonedCurrentUserInfo.physical_address_line_2 !== this.getClaimValueFromControl(this.addressLine2FormControl, AppConsts.ClaimTypes.physical_address_line_2);
        var suburbChanged = this.clonedCurrentUserInfo.physical_address_suburb !== this.getClaimValueFromControl(this.suburbFormControl, AppConsts.ClaimTypes.physical_address_suburb);
        var cityChanged = this.clonedCurrentUserInfo.physical_address_city !== this.getClaimValueFromControl(this.cityFormControl, AppConsts.ClaimTypes.physical_address_city);
        var postalCodeChanged = this.clonedCurrentUserInfo.physical_address_code !== this.getClaimValueFromControl(this.postalCodeControl, AppConsts.ClaimTypes.physical_address_code);
        return occupationChanged || addressLine1Changed || addressLine2Changed || suburbChanged || cityChanged || postalCodeChanged;
    };
    MySettingsModalComponent.prototype.save = function (saveForm) {
        var _this = this;
        if (this.editDetailType === 'other') {
            this.addressLine1FormControl.markAsTouched();
            this.suburbFormControl.markAsTouched();
            this.cityFormControl.markAsTouched();
            this.postalCodeControl.markAsTouched();
            this.occupationFormControl.markAsTouched();
            this.addressLine2FormControl.markAsTouched();
            if (this.addressLine1FormControl.invalid || this.suburbFormControl.invalid || this.cityFormControl.invalid ||
                this.postalCodeControl.invalid || this.occupationFormControl.invalid || this.addressLine2FormControl.invalid) {
                return;
            }
        }
        this.saving = true;
        this.saving = false;
        var claimList = new ModifyClaimDto();
        claimList.userClaimEditDtos = new Array();
        abp.ui.setBusy();
        if (this.editDetailType === 'all') {
            this.addClaim(claimList, AppConsts.ClaimTypes.given_name, this.currentUserInfo.given_name);
            this.addClaim(claimList, AppConsts.ClaimTypes.family_name, this.currentUserInfo.family_name ? this.currentUserInfo.family_name.toString() : '');
            this.addClaim(claimList, AppConsts.ClaimTypes.birthdate, moment(this.restrictionDateValue).format('DD/MM/YYYY hh:mm:ss A'));
            this.addClaim(claimList, AppConsts.ClaimTypes.gender, this.selectedGender);
            this.addClaim(claimList, AppConsts.ClaimTypes.medical_scheme_membership_number, this.currentUserInfo.medical_scheme_membership_number);
        }
        if (this.editDetailType === 'all' || this.editDetailType === 'other') {
            if (this.hasOtherFieldsChanged()) {
                this.addClaim(claimList, AppConsts.ClaimTypes.occupation, this.getClaimValueFromControl(this.occupationFormControl, AppConsts.ClaimTypes.occupation));
                var selectedOccupation = this.occupations.find(function (o) { return (o.Title ? o.Title : o) === _this.getClaimValueFromControl(_this.occupationFormControl, AppConsts.ClaimTypes.occupation); });
                var occupationCategory = selectedOccupation && selectedOccupation.Description
                    ? selectedOccupation.Description.replace(/\s+/g, '_')
                    : undefined;
                if (occupationCategory) {
                    this.addClaim(claimList, AppConsts.ClaimTypes.occupation_category, occupationCategory);
                }
                this.addClaim(claimList, AppConsts.ClaimTypes.physical_address_line_1, this.getClaimValueFromControl(this.addressLine1FormControl, AppConsts.ClaimTypes.physical_address_line_1));
                this.addClaim(claimList, AppConsts.ClaimTypes.physical_address_line_2, this.getClaimValueFromControl(this.addressLine2FormControl, AppConsts.ClaimTypes.physical_address_line_2));
                this.addClaim(claimList, AppConsts.ClaimTypes.physical_address_suburb, this.getClaimValueFromControl(this.suburbFormControl, AppConsts.ClaimTypes.physical_address_suburb));
                this.addClaim(claimList, AppConsts.ClaimTypes.physical_address_city, this.getClaimValueFromControl(this.cityFormControl, AppConsts.ClaimTypes.physical_address_city));
                this.addClaim(claimList, AppConsts.ClaimTypes.physical_address_code, this.getClaimValueFromControl(this.postalCodeControl, AppConsts.ClaimTypes.physical_address_code));
            }
            if (this.editDetailType === 'other') {
                var now = moment().format('DD/MM/YYYY hh:mm:ss A');
                if (this.hasOtherFieldsChanged() || this.currentUserInfo.occupation_confirmation_date === undefined || this.currentUserInfo.occupation_confirmation_date === null || this.currentUserInfo.occupation_confirmation_date === '') {
                    this.addClaim(claimList, AppConsts.ClaimTypes.occupation_confirmation_date, now);
                }
                if (this.hasOtherFieldsChanged() || this.currentUserInfo.address_confirmation_date === undefined || this.currentUserInfo.address_confirmation_date === null || this.currentUserInfo.address_confirmation_date === '') {
                    this.addClaim(claimList, AppConsts.ClaimTypes.address_confirmation_date, now);
                }
            }
        }
        claimList.accessToken = this._authService.user.access_token;
        claimList.userId = this.currentUserInfo.sub;
        this._claimModifyService.modifyClaim(claimList).subscribe(function () {
            abp.event.trigger('updateProfileName');
            if (_this.editDetailType === 'other' && _this.hasOtherFieldsChanged()) {
                //Send notification email to support team for verification of other details when other details are edited
                _this._emailService.sendGenericCustomerSupportMail({
                    subject: "Occupation and address verified - " + claimList.userId,
                    contentTitle: 'Occupation and address verified'.toUpperCase(),
                    firstName: _this.currentUserInfo.given_name,
                    lastName: _this.currentUserInfo.family_name,
                    emailAddress: _this.currentUserInfo.email,
                    cellNumber: _this.currentUserInfo.phone_number.toString(),
                    content: "The occupation and/or address details for " + _this.currentUserInfo.given_name + " " + _this.currentUserInfo.family_name + " have been updated and need to be verified.  New details are as follows: <br/><br/>\n                    Occupation: <b>" + _this.getClaimValueFromControl(_this.occupationFormControl, AppConsts.ClaimTypes.occupation) + "</b> <br/>\n                    Physical Address Line 1: <b>" + _this.getClaimValueFromControl(_this.addressLine1FormControl, AppConsts.ClaimTypes.physical_address_line_1) + "</b> <br/>\n                    Physical Address Line 2: <b>" + _this.getClaimValueFromControl(_this.addressLine2FormControl, AppConsts.ClaimTypes.physical_address_line_2) + "</b> <br/>\n                    Physical Address Suburb: <b>" + _this.getClaimValueFromControl(_this.suburbFormControl, AppConsts.ClaimTypes.physical_address_suburb) + "</b> <br/>\n                    Physical Address City: <b>" + _this.getClaimValueFromControl(_this.cityFormControl, AppConsts.ClaimTypes.physical_address_city) + "</b> <br/>\n                    Physical Address Postal Code: <b>" + _this.getClaimValueFromControl(_this.postalCodeControl, AppConsts.ClaimTypes.physical_address_code) + "</b> <br/>",
                    toAddress: abp.setting.values['SupportEmail.To'],
                    userId: claimList.userId,
                }).subscribe(function (res) {
                    _this.lastTabActive ? _this.saveContinueSubmit('SavedSuccessfully', null) : _this.saveContinueSubmit('ChangesSavedSuccessfully', saveForm);
                    console.log('Notification email sent for other details verification.');
                });
            }
            else {
                _this.lastTabActive ? _this.saveContinueSubmit('SavedSuccessfully', null) : _this.saveContinueSubmit('ChangesSavedSuccessfully', saveForm);
            }
        }, function (error) {
            abp.ui.clearBusy();
            console.log(error);
        });
    };
    MySettingsModalComponent.prototype.saveContinueSubmit = function (value, saveForm) {
        if (value === 'SavedSuccessfully') {
            this.notify.info(this.l('SavedSuccessfully'));
            abp.ui.clearBusy();
            this.close();
        }
        else {
            this.notify.info(this.l('ChangesSavedSuccessfully'));
            if (saveForm != null) {
                if (this.tabIndex !== 4) {
                    this.tabIndex = this.tabIndex + 1;
                }
                // tslint:disable-next-line: no-unused-expression
                this.tabIndex === 4 ? this.lastTabActive = true : null;
                this.nameDisabled = true;
                this.surnameDisabled = true;
                this.schemeDisabled = true;
                this.genderDisabled = true;
                this.birthdayDisabled = true;
            }
            abp.event.trigger('getExistsUserInfo');
            abp.ui.clearBusy();
        }
        this.modalSave.emit(null);
    };
    MySettingsModalComponent.prototype.onValueChange = function (value) {
        var restrictionyear = new Date().getFullYear() - 18;
        var selectedFullyear = value != null ? value.getFullYear() : null;
        if (selectedFullyear >= restrictionyear) {
            this.restrictionMessage = true;
            this.saving = true;
        }
        else {
            this.restrictionMessage = false;
            this.saving = false;
        }
    };
    MySettingsModalComponent.prototype.onChange = function (value) {
        if (value === '') {
            this.restrictionMessage = false;
        }
        this.restrictionDateValue = value;
    };
    MySettingsModalComponent.prototype.edit = function (value) {
        var _this = this;
        this.nameDisabled = true;
        this.surnameDisabled = true;
        this.schemeDisabled = true;
        this.genderDisabled = true;
        this.birthdayDisabled = true;
        this._authService.getUser(function (res) {
            _this.currentUserInfo = res;
            _this.selectedGender = _this.currentUserInfo.gender;
            var birthDate = _this.currentUserInfo.birthdate;
            _this.restrictionDateValue = moment(birthDate, 'DD/MM/YYYY hh:mm:ss A').toDate();
        });
        switch (value) {
            case 'name':
                this.nameDisabled = false;
                break;
            case 'surname':
                this.surnameDisabled = false;
                break;
            case 'birthday':
                this.birthdayDisabled = false;
                break;
            case 'gender':
                this.genderDisabled = false;
                break;
            case 'scheme':
                this.schemeDisabled = false;
                break;
        }
    };
    return MySettingsModalComponent;
}(AppComponentBase));
export { MySettingsModalComponent };
